module.exports = __webpack_public_path__ + "assets/80313508b134bd82acdff5dab5644cb0.mp3";